import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNotification } from "../../context/NotificationContext";

const PaiementArtisan = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { totalPrice = 0, email = "" } = location.state || {};

  useEffect(() => {
    if (!totalPrice || totalPrice <= 0) {
      showNotification("Montant invalide. Retour à l'accueil.", "danger");
      navigate("/");
      return;
    }

    const initiatePayment = async () => {
      try {
        
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/stripe/create-artisan-subscription`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount : totalPrice,
            email: email
          }),
        });

        const data = await response.json();
        if (data.url) {
          window.location.href = data.url; // Redirection Stripe
        } else {
          showNotification("Erreur de création de la session de paiement.", "danger");
        }
      } catch (error) {
        console.error("Erreur lors du paiement artisan :", error);
        showNotification("Erreur de connexion serveur.", "danger");
      }
    };

    initiatePayment();
  }, [navigate, totalPrice, email, showNotification]);

  return (
    <div className="text-center mt-5">
      <h2>Préparation du paiement sécurisé...</h2>
      <p>Merci de patienter quelques secondes.</p>
    </div>
  );
};

export default PaiementArtisan;
